import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export const ProtectedRoute = ({ children, requireAdmin = false, requireStaff = false, requireMember = false }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{
            width: 40, height: 40, border: '3px solid #e5e7eb',
            borderTopColor: '#0f2b4b', borderRadius: '50%',
            animation: 'spin 0.8s linear infinite', margin: '0 auto 1rem'
          }} />
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    if (requireMember) return <Navigate to="/memberLogin" replace />;
    return <Navigate to="/adminLogin" replace />;
  }

  if (requireAdmin && user.role !== 'admin') {
    return <Navigate to="/AdminDashboard" replace />;
  }

  if (requireStaff && user.type !== 'staff') {
    return <Navigate to="/memberPortal" replace />;
  }

  if (requireMember && user.type !== 'member') {
    return <Navigate to="/AdminDashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;
